import {
  doc,
  getDoc,
  setDoc,
  collection,
  getDocs,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

export const getAllPortalLayouts = async () => {
  const snap = await getDocs(collection(db, "portalLayouts"));

  return snap.docs
    .map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }))
    .sort((a, b) => a.id.localeCompare(b.id));
};

export const deletePortalLayout = async (layoutId) => {
  await deleteDoc(doc(db, "portalLayouts", layoutId));
};

export const makeLayoutId = ({ state, grade, subject, view }) => {
  return `${state}_${grade}_${subject}_${view}`.toLowerCase();
};

export const getPortalLayout = async (layoutId) => {
  const ref = doc(db, "portalLayouts", layoutId);
  const snap = await getDoc(ref);

  if (!snap.exists()) return null;

  return {
    id: snap.id,
    ...snap.data(),
  };
};

export const savePortalLayout = async (layoutId, layoutData) => {
  const ref = doc(db, "portalLayouts", layoutId);

  await setDoc(
    ref,
    {
      ...layoutData,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  
};